const japaneseTranslation = {
    translation:{
        "en": "英語",
        "sp": "スペイン語",
        "jp": "日本人",
        "brand": "ディエゴ",
        "about": "約",
        "experience": "経験",
        "projects": "プロジェクト",
        "carrier": "ソフトウェアエンジニア",
        "cv": "履歴書",
        "cv-pdf": "./assets/docs/BTDF_CV_ENG.pdf",
        "salutate": 'こんにちは、私は',
        "full-name": 'ディエゴフェルナンドトレナド',
        "goal": "私はメキシコを拠点とするフルスタック開発者、メイカー、およびコンピューターシステムエンジニアです。ウェブアプリケーションの設計、開発、最適化に情熱を持っています。現在、クラウドプロバイダーを使用してスケーラブルで信頼性の高い製品を構築しており、さまざまなプロジェクトでウェブサイトの美観、パフォーマンス、機能性の向上にも取り組んでいます。",
        "contact": '連絡先',
        "hire": 'コントラター',
        "about-title": "私について",
        "about-me-1": 'こんにちは私の名前はディエゴです。プログラミングとデザインにとても情熱を注いでいます。 趣味で2017年からウェブ用のものを作り始めました。',
        "about-me-2": '私は自分のスキルを学び、向上させるために、さまざまな企業と協力する機会がありました。 私は結果志向の人であり、常に各プロジェクトに最適なソリューションを考え出そうとしています。',
        "about-me-3": 'これらは、私が今日使用しているテクノロジーの一部です。',
        "about-me": "私は、フロントエンド、バックエンド、モービル、デスクトップ開発の経験を持つソフトウェアエンジニアです。 ウェブアプリの作成に関する専門的な経験があります。 現実世界とデジタルのインターフェースを接続して作成するのが好きです。 機能的で魅力的なシステムを開発しています",
        "tech-stack": "マイテックスタック",
        "contact-me": "連絡先",
        "email": "Eメール",
        "name": "名前",
        "message": "メッセージ",
        "send": "送る",
        "reset": "リセット",
        "developed" : "によって開発されました",

        "recent-projects": "最近のプロジェクト",


        "name-project-1": "Encargamelo. Online orders for restaurants",
        "tech-project-1": "Firebase, Cloud Firestone, React, Tailwind CSS",
        "description-project-1": "Platform that allows restaurants to manage and publish their menus, and customers to place orders directly on the restaurant's specific menu page.",
        "img-project-1": "/assets/images/projects/encargamelo.png",
        "github-project-1": "https://github.com/SakugaCoder/Automotive-parts-detection",

        "name-project-2": "Documet manager system",
        "tech-project-2": "Python, Flask, MySQL, Ubuntu Server, React, Styled-Components",
        "description-project-2": "Web platform to manage business documents, with a role and permission system, and a control panel for user and document management.",
        "img-project-2": "/assets/images/projects/Dashboard.jpg",
        "github-project-2": "https://github.com/SakugaCoder/GloveController",

        "name-project-3": "AI chatbot for tire sales",
        "tech-project-3": "Lambda, API Gateway, Facebok Cloud API, OpenAI Assistant API, Python",
        "description-project-3": "WhatsApp-based assistant to manage and promote tire sales, using a Serverless architecture, the OpenAI Assistant API, and the Facebook Cloud API.",
        "img-project-3": "/assets/images/projects/chat.png",
        "github-project-3": "https://github.com/SakugaCoder/ThingsToBuy-ReactJS"
    
    }
};

export default japaneseTranslation;